import axios from 'axios';
import User from "@/models/user";
import {apollo} from "@/apollo";

const API_URL = '/api/auth/';

class AuthService {
    login(user: User) {
        // eslint-disable-next-line no-console
        console.log('AuthService - login');
        // eslint-disable-next-line no-console
        console.log(user.office);
        return axios
            .post(API_URL + 'signin', {
                username: user.username,
                password: user.password,
                office: user.office
            })
            .then(this.handleResponse)
            .then(response => {
                // eslint-disable-next-line no-console
                console.log(response);
                if (response.data.token) {
                    localStorage.setItem('user', JSON.stringify(response.data));
                    apollo.initClient(response.data.token, response.data.office);
                }

                return response.data;
            });
    }

    logout() {
        localStorage.removeItem('user');
        apollo.removeClient();
    }

    register(user: User) {
        return axios.post(API_URL + 'signup', user);
    }

    handleResponse(response: any) {
        // eslint-disable-next-line no-console
        console.log("handleResponse");
        // eslint-disable-next-line no-console
        console.log(response);
        if (response.status === 401) {
            this.logout();
            location.reload();

            const error = response.data && response.data.message;
            return Promise.reject(error);
        }

        return Promise.resolve(response);
    }
}

export default new AuthService();
